import { render, staticRenderFns } from "./StudioProductEvents.vue?vue&type=template&id=7cb6adfb&scoped=true&"
import script from "./StudioProductEvents.vue?vue&type=script&lang=js&"
export * from "./StudioProductEvents.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductEvents.vue?vue&type=style&index=0&id=7cb6adfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb6adfb",
  null
  
)

export default component.exports